module.exports = __webpack_public_path__ + "img/horizontal_6_3_pp3_7016.2596f8ec.png";